import React from 'react'
import ArrowRight from '@/components/icons/ArrowRight'

interface FeatureItemProps {
  title: string
  onClick: () => void
}

const FeatureItem: React.FC<FeatureItemProps> = ({ title, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between bg-gradient-to-r from-[rgba(254,153,33,0.05)] to-[rgba(255,66,59,0.05)] rounded-md h-12 px-3 mb-2">
      <span className={`text-base font-bold text-[#682B01]`}>{title}</span>
      <ArrowRight size={20} color="rgba(40, 40, 40, 0.8)" />
    </div>
  )
}

export default FeatureItem
